import type { GetEnrollment200CertificatesItem } from './getEnrollment200CertificatesItem';
import type { GetEnrollment200EnrollmentType } from './getEnrollment200EnrollmentType';
import type { GetEnrollment200Progress } from './getEnrollment200Progress';
import type { GetEnrollment200Status } from './getEnrollment200Status';

export type GetEnrollment200 = {
  /**
   * 취소 사유
   * @nullable
   */
  cancellationReason?: string | null;
  /**
   * 수강 취소 일시
   * @nullable
   */
  cancelledAt?: string | null;
  /** 수료증 목록 */
  certificates?: GetEnrollment200CertificatesItem[];
  /**
   * 수강 완료 일시
   * @nullable
   */
  completedAt?: string | null;
  /** 강좌 ID */
  courseId: string;
  /** 수강신청 일시 */
  enrolledAt: string;
  /** 수강신청 고유 ID */
  enrollmentId: string;
  /** 수강신청 번호 */
  enrollmentNumber: string;
  /** 수강신청 유형 */
  enrollmentType: GetEnrollment200EnrollmentType;
  /** 수료증 보유 여부 */
  hasCertificate?: boolean;
  progress: GetEnrollment200Progress;
  /** 수강신청 상태 */
  status: GetEnrollment200Status;
  /** 학생 ID */
  studentId: string;
  /**
   * 수강 유효 기간
   * @nullable
   */
  validUntil?: string | null;
};
